/**
 * 보고서 정보 정규화 유틸리티
 * 테이블 데이터와 API 응답 데이터를 일관된 형식으로 변환
 */

/**
 * 보고서 정보를 정규화된 형식으로 변환
 * 테이블 데이터와 API 응답 데이터 모두 처리 가능
 * 
 * @param {Object} data - 보고서 데이터 (테이블 또는 API 응답)
 * @param {string} source - 데이터 소스 ('table' | 'api', 기본값: 'api')
 * @returns {Object} 정규화된 보고서 정보
 * @example
 * // 테이블 데이터
 * normalizeReportInfo({ name: '보고서명', site: { name: '사이트명' }, examineDate: '2025-01-01' }, 'table')
 * // => { reportName: '보고서명', siteName: '사이트명', examineDate: '2025-01-01' }
 * 
 * // API 응답 데이터
 * normalizeReportInfo({ name: '보고서명', _embedded: { site: { name: '사이트명' } }, examineDate: '2025-01-01' }, 'api')
 * // => { reportName: '보고서명', siteName: '사이트명', examineDate: '2025-01-01' }
 */
export const normalizeReportInfo = (data, source = 'api') => {
  if (!data) {
    return {
      reportName: '',
      siteName: '',
      examineDate: ''
    };
  }

  if (source === 'table') {
    // 테이블 데이터 형식: { name, site: { name, id, ... }, examineDate }
    // site가 객체인 경우 name 속성 추출
    let siteName = '';
    if (data.site) {
      if (typeof data.site === 'object' && data.site !== null) {
        // site 객체에서 name 추출
        siteName = data.site.name || '';
      } else if (typeof data.site === 'string') {
        siteName = data.site;
      }
    }
    // siteName이 없으면 다른 경로에서 시도
    if (!siteName) {
      siteName = data.siteName || '';
    }
    
    return {
      reportName: data.name || data.reportName || '',
      siteName: siteName,
      examineDate: data.examineDate || ''
    };
  } else {
    // API 응답 형식: { name, _embedded: { site: { name } }, examineDate }
    // 여러 가능한 구조를 모두 처리
    const siteName = data._embedded?.site?.name || 
                     data.site?.name || 
                     (typeof data.site === 'string' ? data.site : '') ||
                     data.siteName || '';
    
    return {
      reportName: data.name || data.reportName || '',
      siteName: siteName,
      examineDate: data.examineDate || ''
    };
  }
};

